import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { sendVisitNotification } from '../services/visitsApi';

/**
 * Компонент для отслеживания посещений страниц
 * Отправляет уведомления в Telegram при каждом посещении страницы
 */
const VisitTracker = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Отправляем уведомление о посещении страницы
    const trackVisit = async () => {
      try {
        const visitData = {
          page: location.pathname,
          referrer: isFirstRender.current ? document.referrer : `${window.location.origin}${location.pathname}`,
          userAgent: navigator.userAgent,
        };

        await sendVisitNotification(visitData);
        
        // Логируем для отладки
        console.log('Page visit tracked:', {
          page: visitData.page,
          referrer: visitData.referrer,
          timestamp: new Date().toISOString(),
        });
      } catch (error) {
        console.error('Failed to track visit:', error);
      }
    };

    // Отправляем уведомление
    trackVisit();

    // После первого рендера меняем флаг
    if (isFirstRender.current) {
      isFirstRender.current = false;
    }
  }, [location.pathname]); // Срабатывает при каждом изменении пути

  return null; // Компонент не рендерит ничего
};

export default VisitTracker;
